import { fmtDate, fmtTime, money } from "./format";

const stopLines = (b, type) =>
  (b.extra_stops || []).filter((s) => s.type === type).map((s, i) => `${type === "pickup" ? "Extra pickup" : "Extra drop-off"} ${i + 1}: ${s.address}`);

const pricingLine = (b) => {
  if (b.pricing_type === "fixed") return `Fixed price: ${money(b.fixed_price)}`;
  if (b.pricing_type === "cubic")
    return `Share load: ${money(b.price_per_m3)} per m³${b.cubic_metres ? ` (est. ${b.cubic_metres} m³)` : ""}`;
  return `Hourly rate: ${money(b.hourly_rate)}/hr${b.callout_hours ? ` + ${b.callout_hours} hr call-out` : ""}`;
};

const extraLines = (b) => (b.driver_extras || []).map((e) => `Extra – ${e.type}${e.description ? ` (${e.description})` : ""}: ${money(e.amount)}`);

export function customerConfirmation(b) {
  const lines = [
    "BOOKING CONFIRMATION",
    "",
    `Hi ${b.customer_name},`,
    "Thank you for your booking. Your move is confirmed:",
    "",
    `Job number: ${b.job_number}`,
    `Moving date: ${fmtDate(b.moving_date, "EEEE d MMMM yyyy")}`,
    `Start time: ${b.confirmation_time || fmtTime(b.start_time)}`,
    b.job_type ? `Service: ${b.job_type}` : null,
    `Pickup: ${b.pickup_address}`,
    ...stopLines(b, "pickup"),
    ...stopLines(b, "delivery"),
    `Delivery: ${b.delivery_address}`,
    b.men ? `Movers: ${b.men} removalists` : null,
    b.truck_size ? `Truck: ${b.truck_size}` : null,
    b.cubic_metres ? `Estimated volume: ${b.cubic_metres} m³` : null,
    "",
    "Payment",
    pricingLine(b),
    b.callout_fee ? `Call-out fee: ${money(b.callout_fee)}` : null,
    b.additional_charges ? `Additional charges: ${money(b.additional_charges)}${b.additional_charges_note ? ` (${b.additional_charges_note})` : ""}` : null,
    ...extraLines(b),
    b.deposit_amount ? `Deposit received: ${money(b.deposit_amount)}${b.deposit_method ? ` (${b.deposit_method})` : ""}` : null,
    b.pricing_type === "hourly" ? "Final balance is calculated on the day based on time taken." : `Outstanding balance: ${money(b.remaining_balance)}`,
    b.customer_notes ? `\nNotes: ${b.customer_notes}` : null,
    "",
    "If anything changes or you have any questions, just reply to this message.",
    "",
    "Kind regards,",
    "The Bookings Team",
  ];
  return lines.filter((l) => l !== null).join("\n");
}

export function crewBrief(b) {
  const lines = [
    "JOB DETAILS",
    `Job No: ${b.job_number}`,
    `Customer: ${b.customer_name}`,
    `Phone: ${b.mobile}`,
    `Date: ${fmtDate(b.moving_date, "EEE d MMM yyyy")}${b.start_time ? ` – ${fmtTime(b.start_time)}` : ""}`,
    `Lead from: ${b.lead_source || b.bill_to_company || "Direct"}`,
    b.bill_to_company ? `Company: ${b.bill_to_company}` : null,
    `Men on job: ${b.men || "TBC"}`,
    `Truck size: ${b.truck_size || "TBC"}`,
    `Estimated CBM: ${b.cubic_metres ? `${b.cubic_metres} m³` : "TBC"}`,
    b.truck_assigned ? `Truck: ${b.truck_assigned}` : null,
    "",
    `Pickup: ${b.pickup_address}`,
    ...stopLines(b, "pickup"),
    ...stopLines(b, "delivery"),
    `Delivery: ${b.delivery_address}`,
    "",
    `Details: ${[b.job_notes, b.special_requirements].filter(Boolean).join("\n") || "None"}`,
  ];
  return lines.filter((l) => l !== null).join("\n");
}
